import { merge } from "lodash-es";

import { initialPreferences } from "./initial-preferences";
import { Preferences } from "./preferences";
import { useABTestingPreferences } from "./use-ab-testing-preferences";
import { useManualPreferences } from "./use-manual-preferences";
import { usePreferencesLocalSwr } from "./use-preferences-local-swr";

export function usePreferences(): usePreferencesReturn {
  const manualPreferences = useManualPreferences();

  if (manualPreferences !== undefined)
    return { preferences: manualPreferences, hasPersistedPreferences: true };

  // eslint-disable-next-line react-hooks/rules-of-hooks
  return usePersisted();
}

export type usePreferencesReturn = {
  preferences: Preferences;
  hasPersistedPreferences: boolean;
};

function usePersisted(): usePreferencesReturn {
  const { data } = usePreferencesLocalSwr();
  const abTestingPreferences = useABTestingPreferences();

  return {
    preferences: merge({}, initialPreferences, abTestingPreferences, data),
    hasPersistedPreferences: data !== null,
  };
}
